import { toGregorian } from '../../_jalali/index.js';
/**
 *
 * @param args
 * @returns {Date}
 */

export default function newDate() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length > 1) {
    var year = args[0],
        month = args[1],
        _args$ = args[2],
        day = _args$ === void 0 ? 1 : _args$,
        rest = args.slice(3);
    var g = toGregorian(year, month + 1, day);
    return new Date(...[g.gy, g.gm - 1, g.gd, ...rest]);
  }

  return new Date(...args);
}